/**
 * @see https://stackoverflow.com/questions/31338235/webrtc-renegotiation-in-firefox/31356795#31356795
 */
const fixRemoveStream = (): void => {
    if (window.mozRTCPeerConnection) {
        window.mozRTCPeerConnection.prototype.removeStream = function (stream: MediaStream): void {
            this.getSenders().forEach((sender: RTCRtpSender) => {
                if (sender.track) {
                    stream.getTracks().includes(sender.track) && this.removeTrack(sender);
                }
            });
        }
    }
}

export {
    fixRemoveStream
}
